<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <el-header class="el-header">
      <h2 class="el-row1">语言学能测试（Version 1.0）</h2>
      <h2 class="el-row1"> Tests of Aptitude for Language Learning (Version 1.0)</h2>
    </el-header>
    <el-row>
      <el-col :span="10">
        <div class="reenter">
          <el-button class="Resaccess" type="primary" plain @click="NextLoginRe">
            研究者入口 <br/> <br/>Researcher Entry
          </el-button>
        </div>

      </el-col>
      <el-col :span="8">
        <div class="enter">
          <el-button class="takeraccess" type="primary" plain @click="NextLoginTestA">
            被测者入口 - 视听版 <br/><br/>  Test-taker Entry - Aural Suite
          </el-button>
        </div>
        <div class="enter">
          <el-button class="takeraccess" type="primary" plain @click="NextLoginTestW">
            被测者入口 - 文字版 <br/><br/> Test-taker Entry - Written Suite
          </el-button>
        </div>
      </el-col>

      <!-- <el-col :span="6">
        <div style="margin-top: 300px;margin-right: 50px">
          <p style="font-size: 14pt;color: #605F5F">我们正在对TALL测试平台进行维护，暂时不能使用测试进行数据收集。</p>
          <p style="font-size: 14pt;color: #605F5F">We are currently undergoing maintenance on the TALL testbed. It cannot be used for data collection at this time.</p>
        </div>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  name: "BeforeTest",
  methods:{
    NextLoginRe() {
      console.log('登录注册')
      this.$router.push('/ResearcherLogin');

    },
    NextLoginTestA() {
      console.log('登录注册测试者')
      this.$router.push('/BeforeLogin');

    },
    NextLoginTestW() {
      window.location.href = 'https://tall-webtest.com/written/#/BeforeLogin';
      // window.location.href = 'http://localhost:8081/#/BeforeLogin'
    },
  }
}
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #DCDCDC ;

}

.el-header{
  display: flex;
  flex-direction: column;
  height: 30vh;
  background-color: #D8D8D8;

}

.el-row1{
  font-size:24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;


}

.el-row{
  font-size:24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;


}

el-button{
  background: #0ABBF9;
}


.enter{
  display: flex;
  width: 500px;
  height: 50px;
  margin-top: 200px;
  margin-right: 30px;
  margin-left: 10px;
}

.reenter{
  display: flex;
  width: 500px;
  height: 50px;
  margin-top: 200px;
  margin-right: 30px;

  margin-left: 200px;
}


.Resaccess{
  width: 25rem;
  height: 6rem;
  font-size: 24px;

}

.takeraccess{
  width: 25rem;
  height: 6rem;
  font-size: 24px;
}

</style>